import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlendedCurveModalDataModel } from '@features/blended-curve-modal/blended-curve-modal-data.model';
import { BlendedCurveModalDirective } from '@features/blended-curve-modal/blended-curve-modal.component';

import { SiteCurveService } from '@models/site-curve/site-curve.service';
import { SiteCurveModel } from '@models/site-curve/site-curve.store';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { InputComponent } from '@shared/components/input/input.component';
import { ModalComponent } from '@shared/components/modals/modal/modal.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import {
  CreateDriverBlendedSiteDistributionInput,
  createDriverBlendedSiteDistributionMutation,
  SiteGroup,
  UpdateDriverBlendedSiteDistributionInput,
  updateDriverBlendedSiteDistributionMutation,
} from '@shared/services/gql.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, ModalComponent, CheckboxComponent, InputComponent],
  selector: 'aux-site-blended-curve-modal',
  templateUrl:
    '../../../../../../../../features/blended-curve-modal/blended-curve-modal.component.html',
})
export class SiteBlendedCurveModalComponent extends BlendedCurveModalDirective<
  SiteCurveModel,
  SiteGroup
> {
  private siteCurveService = inject(SiteCurveService);

  constituentGroups: SiteGroup[];

  constructor() {
    const ref =
      inject<CustomOverlayRef<unknown, BlendedCurveModalDataModel<SiteCurveModel>>>(
        CustomOverlayRef
      );

    super();

    this.ref = ref;
    this.constituentGroups = this.ref.data?.blendedCurve?.constituent_site_groups || [];
  }

  createData(): CreateDriverBlendedSiteDistributionInput {
    return {
      name: this.blendedCurveForm.controls.blendedCurveName.value,
      site_group_ids: this.selectedCurveIds,
    };
  }

  createDriverBlendedDistribution(): Promise<
    GraphqlResponse<createDriverBlendedSiteDistributionMutation>
  > {
    return this.siteCurveService.createBlendedSiteCurve(this.createData());
  }

  getGroupId(item: SiteCurveModel): string {
    return item.site_group_id;
  }

  updateData(): UpdateDriverBlendedSiteDistributionInput {
    return {
      blended_group_id: this.ref.data?.blendedCurve?.site_group_id || '',
      name: this.blendedCurveForm.controls.blendedCurveName.value,
      site_group_ids: this.selectedCurveIds,
    };
  }

  updateDriverBlendedDistribution(): Promise<
    GraphqlResponse<updateDriverBlendedSiteDistributionMutation>
  > {
    return this.siteCurveService.updateBlendedSiteCurve(this.updateData());
  }
}
